import { getCookieUid, getCookieUin } from '@tencent/tencent-doc-report';
import { network } from '@tencent/netcheck';
import { getQuery } from 'sutils';
import { getQuerySearchParams } from '@src/slide/infrastructure/module/independent/url/param-operation';
import i18n from '@i18next/i18n';
import { INewDocInfo, IOfflineEditContext } from '../core/interfaces/offline-edit-context.interace';
import { SlideDataServices } from '../../../core/slide-data-services.core';
import { IClientVars } from '../../../core/interfaces/client-vars.interface';

const DEFAULT_FOLDER = '/';
const DEFAULT_TITLE = i18n.t('空白幻灯片');

export class OfflineEditContext implements IOfflineEditContext {
    #newDocInfo: INewDocInfo;

    public get newDocInfo(): INewDocInfo {
        if (!this.#newDocInfo) {
            this.#newDocInfo = {
                secretId: this.secretId,
                globalPadId: this.globalPadId,
                title: this.title,
                folder: this.folder,
            };
        }
        return this.#newDocInfo;
    }

    public get uid(): string {
        return getCookieUid() || '';
    }
    public get uin(): string {
        return window.isInWorker ? '' : (getCookieUin() || '');
    }

    public get secretId(): string {
        const id = window.location.pathname.split('/').pop();
        return id || '';
    }

    public get secretId4New(): string {
        return this.newDocInfo.secretId || this.secretId;
    }

    public get globalPadId(): string {
        return getQuery('globalPadId') || SlideDataServices.DocInfoManager()?.globalPadId || (window.clientVars as IClientVars)?.globalPadId;
    }

    public get globalPadId4New(): string {
        return this.newDocInfo.globalPadId || this.globalPadId;
    }

    public get localPadId(): string {
        return getQuery('localPadId') || '';
    }

    public get title(): string {
        return getQuerySearchParams('title');
    }

    public get title4New(): string {
        return this.newDocInfo.title || this.title || DEFAULT_TITLE;
    }

    public get folder(): string {
        return getQuery('folder');
    }

    public get folder4New(): string {
        return this.newDocInfo.folder || this.folder || DEFAULT_FOLDER;
    }

    public get isOnlineBorrowed(): string {
        return getQuery('isOnlineBorrowed');
    }

    //
    public isNewCreate(): boolean {
        return !!getQuery('new');
    }

    /**
     * 创建文档所需基础数据更新
     * 主要场景: 根据本地数据库已有数据创建
     * @param newDocInfo
     */
    public updateCreateDocInfo = (newDocInfo: INewDocInfo) => {
        this.#newDocInfo = {
            secretId: newDocInfo.secretId,
            globalPadId: newDocInfo.globalPadId,
            title: newDocInfo.title,
            folder: newDocInfo.folder,
        };
    };

    public isOnline(): boolean {
        return network.isOnline;
    }

    /**
    * create message seq
    */
    public createMessageSeq(): number {
        const randSeed: number = new Date().getTime();
        const randRange = 2147483648; // 4个byte
        let seq = Math.ceil(Math.random() * randRange);
        seq += randSeed;
        return seq;
    }
}
